import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  colorPicker: {
    cursor: 'pointer !important',

    '& input': {
      cursor: 'pointer !important',
    },
  },
  popover: {
    position: 'absolute',
    zIndex: 2,
    cursor: 'auto',
  },
  cover: {
    position: 'fixed',
    zIndex: -1,
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
}));
